import {
    Injectable,
    ComponentFactoryResolver,
    ApplicationRef,
    Injector,
    EmbeddedViewRef,
    ComponentRef,
    Type,
} from '@angular/core';
import { ModalComponent } from '../components/modal/modal.component';
import { RoblexModalModule } from '../components/modal/modal.module';
import { RoblexModalConfig } from '../config/modal/modal.config';
import { RoblexModalRef } from '../config/modal/modal.ref';
import { RoblexModalInjector } from '../config/modal/modal.injector';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

// export declare const Type: FunctionConstructor;
// export declare interface Type<T> extends Function {
//     new (...args: any[]): T;
// }

@Injectable({  
    providedIn: RoblexModalModule,
})
export class RoblexModalService {
    // /**
    //  * Dialog component ref of neyhaz modal service
    //  */
    // dialogComponentRef: ComponentRef<ModalComponent>;
    /**
     * Unique key of neyhaz modal service
     */
    childUniqueKey: number = 0;
    /**
     * Components references of neyhaz modal service
     */
    componentsReferences = Array<ComponentRef<ModalComponent>>();
    /**
     * Creates an instance of neyhaz modal service.
     * @param compFactoryResolver ComponentFactoryResolver
     * @param appRef ApplicationRef
     * @param injector Injector
     */
    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private appRef: ApplicationRef,
        private injector: Injector
    ) {
        //
    }
    /**
     * Shows neyhaz modal service
     * @template T
     * @param component Type<T>
     * @returns Promise<any>
     */
    show(componentType: Type<any>, config?: RoblexModalConfig) {
        const dialogRef = this.appendDialogComponentToBody(
            Object.assign({ backdrop: true, isLeave: true }, config),
            componentType
        );
        // this.dialogComponentRef.instance.childComponentType = componentType;
        return dialogRef;
    }
    /**
     * Appends dialog component to body
     * @param config NeyhazModalConfig
     * @returns NeyhazModalRef
     */
    private appendDialogComponentToBody(
        config: RoblexModalConfig,
        componentType: Type<any>
    ): RoblexModalRef {
        /**
         * The WeakMap object is a collection of key / value pairs
         * in which the keys are objects and the values ​​are arbitrary values.
         */
        const map = new WeakMap();
        map.set(RoblexModalConfig, config);
        /**
         * ModalRef events
         */
        const dialogRef = new RoblexModalRef();
        map.set(RoblexModalRef, dialogRef);

        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
            ModalComponent
        );
        const componentRef = componentFactory.create(
            new RoblexModalInjector(this.injector, map)
        );

        this.appRef.attachView(componentRef.hostView);

        const domElem = this.componentToHTLMElement(componentRef);

        document.body.appendChild(domElem);
        document.body.classList.add('modal-open');

        // this.dialogComponentRef = componentRef;
        const component = componentRef.instance;
        component.uniqueKey = ++this.childUniqueKey;
        component.childComponentType = componentType;
        /**
         * Remove modal component of body
         */
        const sub = dialogRef.afterClosed.subscribe(() => {
            this.removeModalComponentFromBody(component.uniqueKey);
            sub.unsubscribe();
        });

        this.componentsReferences.push(componentRef);

        return dialogRef;
    }
    /**
     * Removes dialog component from body
     */
    private removeModalComponentFromBody(key: number) {
        let componentRef;

        for (const [index, item] of this.componentsReferences?.entries()) {
            if (item.instance.uniqueKey === key) {
                componentRef = item;
                this.componentsReferences?.splice(index, 1);
            }
        }

        if (componentRef) {
            if (this.componentsReferences.length === 0) {
                document.body.classList.remove('modal-open');
            }

            const domElem: Element = (componentRef.hostView as EmbeddedViewRef<any>)
                .rootNodes[0];
            const dialog: any = domElem.firstChild.firstChild;

            dialog.classList.add('dialog-remove');

            document.body.addEventListener('animationend', (event) => {
                // console.warn(event);
                this.removeElement(event, componentRef);
            });
            document.body.addEventListener('webkitAnimationEnd', (event) => {
                // console.warn(event);
                this.removeElement(event, componentRef);
            });
            // this.appRef.detachView(componentRef.hostView);
            // componentRef.destroy();
        }
    }
    /**
     * Components to htlmelement
     * @param componentRef ComponentRef<ModalComponent>
     * @returns HTMLElement
     */
    private componentToHTLMElement(
        componentRef: ComponentRef<ModalComponent>
    ): HTMLElement {
        return (componentRef.hostView as EmbeddedViewRef<any>)
            .rootNodes[0] as HTMLElement;
    }
    
    private removeElement(
        event,
        componentRef: ComponentRef<ModalComponent>
    ): void {
        if (event.animationName === 'disapearY') {

            this.appRef.detachView(componentRef.hostView);
            componentRef.destroy();

            const modalViewRef = (componentRef.hostView as EmbeddedViewRef<any>)
                .rootNodes[0] as HTMLElement;
            if (modalViewRef) {
                modalViewRef.remove();
            }
        }
    }
}
